// @flow
const validationErrorCode = 2000;

/**
 * Take a serve side validation response and returns the messages
 */
export const parseServerSideValidation = (response: {
  error?: number,
  meta: {
    [string]: Array<string>
  }
}) => {
  if (response?.error === validationErrorCode) {
    const errors = {};

    Object.keys(response.meta).forEach(key => {
      errors[key] = Array.isArray(response.meta[key])
        ? response.meta[key].join(', ')
        : response.meta[key];
    });

    return errors;
  }

  return {};
};

export default null;
